/* eslint-disable @nx/enforce-module-boundaries */
import { Component, Input, Inject } from '@angular/core';

import { NavigationItem } from '@cigna/chcp/shared/util';
import {
  ENVIRONMENT_CONFIG,
  EnvironmentConfig,
} from '@cigna/chcp/shared/environment-util';

import { ChcpFederationFacade } from '@cigna/chcp/shared/federation-data-access';

@Component({
  selector: 'cigna-nav-item',
  templateUrl: './nav-item.component.html',
  styleUrls: ['./nav-item.component.scss'],
})
export class NavItemComponent {
  @Input() navItem: NavigationItem;
  @Input() isTopLevel = false;
  @Input() dataTestAttribute: string;
  @Input() isImpersonator = false;
  @Input() hasChildren = false;
  @Input() isEnhancedBrighterFederation = false;

  isAuth0 = false;

  constructor(
    private federationFacade: ChcpFederationFacade,
    @Inject(ENVIRONMENT_CONFIG) private envConfig: EnvironmentConfig,
  ) {
    this.isAuth0 = this.envConfig.authMethod === 'auth0';
  }

  checkFederation() {
    this.federationFacade.saveBrighterFederationPartnerData();
  }
}
